import React from 'react';
import MentionsBasicEditor from './MentionsBasicEditor';
import {
  convertTextToMentionsState,
  extractPayloadFromMentionContent,
  DEFAULT_MACRO_ENTITY_NAME,
} from '../../../../lib/DraftJSUtils';

function getEditorStateFromProps(props) {
  const { value, suggestions, replaceMacroMap } = props;
  let editorState;

  if (value) {
    editorState = convertTextToMentionsState(
      value,
      suggestions,
      DEFAULT_MACRO_ENTITY_NAME,
      replaceMacroMap,
    );
  } else {
    editorState = convertTextToMentionsState(value);
  }

  return editorState;
}

class MentionsEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filteredSuggestions: props.suggestions,
      editorState: getEditorStateFromProps(props),
    };

    this._handleEditorChange = this._handleEditorChange.bind(this);
    this._handleEditorSearch = this._handleEditorSearch.bind(this);
  }

  // componentDidUpdate(prevProps, prevState) {
  //   /* R16: Comment out unused state change
  //   if (
  //     this.props.value !== prevProps.value ||
  //     this.props.suggestions !== prevProps.suggestions ||
  //     this.props.replaceMacroMap !== prevProps.replaceMacroMap
  //   ) {
  //     // this.setState({ editorState: getEditorStateFromProps(this.props) });
  //   }
  //   */
  // }

  render() {
    const { style, suggestions } = this.props;
    const { filteredSuggestions, editorState } = this.state;

    return (
      <MentionsBasicEditor
        style={{
          width: '100%',
          margin: 0,
          marginBottom: 6,
          padding: 'var(--spacing-md)',
          borderRadius: 4,
          borderColor: '#ccc',
          fontSize: 11,
          color: 'hsl(0,0%,20%)',
          ...style,
        }}
        isSingleLine={false}
        editorState={editorState}
        allSuggestions={suggestions}
        suggestions={filteredSuggestions}
        onChange={this._handleEditorChange}
        onSearchChange={this._handleEditorSearch}
        groupByKey="type"
        groupDisplayNameKey="type_display"
        groupByEntryComponent={<div />}
      />
    );
  }

  _handleEditorChange(editorState) {
    if (editorState.getCurrentContent() !== this.state.editorState.getCurrentContent()) {
      const { suggestions, replaceMacroMap, onValueChanged } = this.props;
      const contentState = editorState.getCurrentContent();
      const { payloadText } = extractPayloadFromMentionContent(
        contentState,
        DEFAULT_MACRO_ENTITY_NAME,
        false,
        suggestions,
        replaceMacroMap,
      );

      onValueChanged(payloadText);
    }

    this.setState({ editorState });
  }

  _handleEditorSearch(filteredSuggestions) {
    this.setState({
      filteredSuggestions,
    });
  }
}

export default MentionsEditor;
